<script setup lang="ts">
import { type IdTitle } from '@itinerary/ItineraryModuleTypes';

interface IProps {
    items?: IdTitle[];
}
const { items = [] } = defineProps<IProps>();
const modelValue = defineModel<string[]>({ default: () => [] });
const selected = ref<Record<string, boolean>>({});
const clear = () => {
    selected.value = {};
};
const changeSelected = (value: boolean, id: string) => {
    const result: Record<string, boolean> = {
        ...selected.value,
        [id]: value,
    };
    selected.value = result;
    modelValue.value = Object.keys(result).filter(k => result[k]);
};
watch(
    modelValue,
    val => {
        const value_ = Object.keys(selected.value).filter(
            k => selected.value[k]
        );
        if (
            (val || []).slice().sort().join() === value_.slice().sort().join()
        ) {
            return;
        }
        selected.value = (val || []).reduce(
            (prev, curr) => ({ ...prev, [curr]: true }),
            {}
        );
    },
    { immediate: true }
);
defineExpose({ clear });
</script>

<template>
    <div>
        <mr-checkbox
            v-for="item in items"
            :key="item.id"
            :model-value="selected[item.id]"
            :label="item.title"
            :description="item.subTitle"
            @update:model-value="val => changeSelected(val, item.id)"
        />
    </div>
</template>

<style scoped lang="scss">
:deep(label) {
    font-size: 11px;
    color: usePalette();
    @include font-weight(bold);
}
</style>
